import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#f9f9fb",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8.477 16.211c.166.097.249.146.366.17.09.02.223.02.314 0 .117-.024.2-.073.366-.17C10.985 15.36 15 12.681 15 9.001V6.15c0-.806 0-1.209-.124-1.495a1.3 1.3 0 0 0-.51-.628c-.255-.18-.755-.283-1.753-.49-1.1-.23-1.945-.643-2.717-1.24-.37-.287-.556-.43-.7-.47a.63.63 0 0 0-.391 0c-.145.04-.33.183-.7.47-.773.597-1.618 1.01-2.718 1.24-.998.207-1.498.31-1.752.49a1.3 1.3 0 0 0-.51.628C3 4.942 3 5.345 3 6.15V9c0 3.682 4.015 6.359 5.477 7.211"
    }, null, -1)
  ]))]))
}
export default { render: render }